export default {
  name: 'Sword Health',
  logo: 'login/sword/logo-primary.svg',
  logoMobile: 'login/sword/logo-primary-mobile.svg',
  loginImage: 'login/sword/login-image.png',

  // zendesk color
  zendeskColor: '#1D3861',

  t: {
    // Condition Selection
    onboarding2_titles_condition: 'eco_area_concern_title',
    eco_area_concern_subtitle: 'eco_int_area_concern_subtitle',
  },
};
